var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCoupon = function SvgIcCoupon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D80C18",
    fillRule: "evenodd",
    d: "M2.53 4.95a.193.193 0 0 0-.192.192v4.14l1.444 1.443-1.444 1.444v4.139c0 .106.086.192.192.192h16.94a.193.193 0 0 0 .193-.192v-4.14l-1.444-1.443 1.444-1.444V5.142a.193.193 0 0 0-.193-.192zm12.327 5.155 1.19.011-.011 1.178-1.574-.126-.841 2.254-1.351-.013-1.054-3.845-1.123 3.825-1.34-.012-.823-2.28-1.72.107.01-1.178 1.33.012-.796-2.196 1.736.016.982 3.8 1.151-3.78 1.25.011 1.077 3.801L14 7.909l1.67.015z",
    clipRule: "evenodd"
  })));
};
export default SvgIcCoupon;